export default {"src":"/uk/_next/static/media/retirementPlannerIcon.3520b273.svg","height":61,"width":60,"blurWidth":0,"blurHeight":0};